import { ELEMENT_ATTRIBUTE_GROUP, ELEMENT_GROUPS } from '../utils';

const RadarChartElementFields = {
  group: ELEMENT_GROUPS.OTHER,
  label: 'Radar Chart',
  icon: 'DocumentTextIcon',
  description: 'Adds a radar chart based on data from the current document',
  properties: [
    'layout',
    {
      label: 'Data Binding Source',
      name: 'datasourceId',
      description: 'Choose a content type this element will get its data from',
      editor: 'dropdown',
      function: {
        name: 'getDynamicDataSources',
        params: ['app.id']
      },
      default: '',
      displayWhen: [
        {
          field: 'databindingDisabled',
          operator: '!==',
          value: true
        }
      ],
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Data Points',
      name: 'datapoints',
      editor: 'textbox',
      description:
        'A comma separated list of field names on the current document that will be displayed in the chart.',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Labels',
      name: 'labels',
      editor: 'textbox',
      description: 'A comma separated list of labels for each data point.',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'Maximum Scale',
      name: 'scale',
      editor: 'number',
      description: 'The maximum scale of each data point.',
      default: 5,
      group: ELEMENT_ATTRIBUTE_GROUP.CONTENT
    },
    {
      label: 'No Chart Data Image',
      name: 'noDataImage',
      editor: 'image',
      mediaLibraryStoreIn: 'custom_folder',
      mediaLibraryPath: 'apps/',
      description: 'An image to display when there is no chart data available',
      default: '',
      group: ELEMENT_ATTRIBUTE_GROUP.IMAGERY
    },
    'fontFamily',
    'color',
    'font',
    'alignment',
    'margin',
    'padding'
  ]
};

export default RadarChartElementFields;
